const ARAPLinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Charge Period", field: "chargePeriod" },
    { headerName: "Country Code", field: "countryCode" },
    { headerName: "Account", field: "account" },
    { headerName: "Amount", field: "amount" },
    { headerName: "Quantity", field: "quantity" },
    { headerName: "Currency", field: "curr" },
    { headerName: "VAT Rate", field: "vatRate" },
    { headerName: "VAT Recharge", field: "vatRecharge" },
    { headerName: "Comments", field: "comments" },
    { headerName: "WTH Tax", field: "wthTax" },
    { headerName: "WTH Rate", field: "wthRate" },
    { headerName: "WTH Amount", field: "wthAmount" },
    { headerName: "Document Date", field: "docDate" },
    { headerName: "Rental Agreement Number", field: "ra" },
    { headerName: "Renter", field: "renter" },
    { headerName: "Document Reference", field: "docRef" },
    { headerName: "Document Number", field: "docNo" },
    { headerName: "Charge Code", field: "chargeCode" },
    { headerName: "STLocCode", field: "stlocCode" },
    { headerName: "WWLocCode", field: "wwlocCode" },
    { headerName: "Total Amount", field: "totalAmount" },
    { headerName: "Template Code", field: "templateCode" },
    { headerName: "Country Name", field: "countryName" },
    { headerName: "Partner Name", field: "partnerName" },
    { headerName: "CL Indicator", field: "clIndicator" },
    { headerName: "COutDate", field: "cOutDate" },
    { headerName: "CREDate", field: "credate" },
    { headerName: "Member Number", field: "memberNumber" },
    { headerName: "Std Points", field: "stdPoints" },
    { headerName: "Bonus Points", field: "bonusPoints" },
    { headerName: "Nett", field: "nett" },
    { headerName: "Cost Points", field: "costPoints" },
    { headerName: "Rental Days", field: "rentalDays" },
    { headerName: "OC", field: "oc" },
    { headerName: "Wizard", field: "wizard" },
    { headerName: "Check out date", field: "rcheckOutDate" },
    { headerName: "Check in date", field: "rcheckInDate" },
    { headerName: "TM Cost", field: "tmcost" },
    { headerName: "Base fee", field: "baseFee" },
    { headerName: "Bonus fee", field: "bonusFee" },
    { headerName: "Base Bonus fee", field: "baseBonusFee" },
    { headerName: "Admin fee", field: "adminFee" },
    { headerName: "Customer Name", field: "customerName" },
    { headerName: "Reservation Number", field: "resvNo" },
    { headerName: "Location Name", field: "locationName" },
    { headerName: "Reservation Resource", field: "reservationResource" },
    { headerName: "GRP", field: "grp" },
    { headerName: "Document Code", field: "docCode" },
    { headerName: "ExtRef4", field: "extRef4" },
    { headerName: "Agency City", field: "agencyCity" },
    { headerName: "Agency Code", field: "agencyCode" },
    { headerName: "Comm amount", field: "commAmt" },
    { headerName: "Process fee", field: "processFee" },
    { headerName: "AP", field: "ap" },
    { headerName: "Element3", field: "element3" },
    { headerName: "ExtRef1", field: "extRef1" },
    { headerName: "ExtRef2", field: "extRef2" },
    { headerName: "ExtRef6", field: "extRef6" },
    { headerName: "Reservation country code", field: "reservationCountryCode" },
    { headerName: "IATA Code", field: "iataCode" },
    { headerName: "Year", field: "year" },
    { headerName: "Month", field: "month" },
    { headerName: "Rental", field: "rental" },
    { headerName: "Qualifying Reservation", field: "qualifyingRev" },
    { headerName: "Reservation Booking date", field: "reservationBookingDate" },
    { headerName: "Reservation status", field: "reservationStatus" },
    { headerName: "CommOnRrr", field: "commOnRrr" },
    { headerName: "Reservation IATA code", field: "reservationIataCode" },
    { headerName: "Reservation Location code", field: "reservationLocationCode" },
    { headerName: "Euro Commission", field: "euroCommission" },
    { headerName: "Country UnName", field: "countryUnName" },
    { headerName: "Rrr Amount", field: "rrrAmount" },
    { headerName: "Rrr Current Amount", field: "rrrCurrentAmount" },
    { headerName: "Rental Individual Name", field: "rentalIndividualName" },
    { headerName: "Rental Check in date", field: "rentalCheckInDate" },
    { headerName: "Rental Currency code", field: "rentalCurrencyCode" },
    { headerName: "Rental IATA code", field: "rentalIataCode" },
    { headerName: "RCommCcyAmt", field: "rCommCcyAmt" },
    { headerName: "RCheckOutLocCode", field: "rcheckOutLocCode" },
    { headerName: "RCheckOutCtryCode", field: "rcheckOutCtryCode" },
    { headerName: "RNetRateInd", field: "rNetRateInd" },
    { headerName: "Country Operator", field: "countryOperator" },
    { headerName: "Recharge Segment", field: "rechargeSegment" },
    { headerName: "Bus Activity Key", field: "busActivityKey" },
    { headerName: "Reservation AWD number", field: "resvAWDNo" },
    { headerName: "Rental Mid", field: "rentalMid" },
    { headerName: "Vehicle registration number", field: "vehicleRegNo" },
    { headerName: "Damage number", field: "damageNo" },
    { headerName: "HSC Invoice number", field: "hscinvoiceNo" },
    { headerName: "Batch Ref number", field: "batchRef" },
    { headerName: "Integer1", field: "integer1" },
    { headerName: "Integer2", field: "integer2" },
    { headerName: "Integer3", field: "integer3" },
    { headerName: "Integer4", field: "integer4" },
    { headerName: "Integer5", field: "integer5" },
    { headerName: "Integer6", field: "integer6" },
    { headerName: "Integer7", field: "integer7" },
    { headerName: "Integer8", field: "integer8" },
    { headerName: "Integer9", field: "integer9" },
    { headerName: "Integer10", field: "integer10" },
    { headerName: "Integer11", field: "integer11" },
    { headerName: "Decimal1", field: "decimal1" },
    { headerName: "Decimal2", field: "decimal2" },
    { headerName: "Decimal3", field: "decimal3" },
    { headerName: "Decimal4", field: "decimal4" },
    { headerName: "Decimal5", field: "decimal5" },
    { headerName: "Decimal6", field: "decimal6" },
    { headerName: "Decimal7", field: "decimal7" },
    { headerName: "Decimal8", field: "decimal8" },
    { headerName: "Decimal9", field: "decimal9" },
    { headerName: "Decimal10", field: "decimal10" },
    { headerName: "Decimal11", field: "decimal11" },
    { headerName: "Decimal12", field: "decimal12" },
    { headerName: "Decimal13", field: "decimal13" },
    { headerName: "Decimal14", field: "decimal14" },
    { headerName: "Decimal15", field: "decimal15" },
    { headerName: "Decimal16", field: "decimal16" },
    { headerName: "Text1", field: "text1" },
    { headerName: "Text2", field: "text2" },
    { headerName: "Text3", field: "text3" },
    { headerName: "Text4", field: "text4" },
    { headerName: "Text5", field: "text5" }
];

export default ARAPLinesColumns;